export const kendoGridInlineStyling = `
.k-textbox {
    font-size: 1.2rem;
}
.k-numerictextbox {
    font-size: 1.2rem;
}
.k-dropdown {
    font-size: 1.2rem;
}
.k-input {
    border-color: rgba(0, 0, 0, 0.54);
    color: rgba(0, 0, 0, 0.87);
    background-color: transparent;
}
.k-input-md, .k-picker-solid {
    font-size: 1.2rem;
}
.k-input-md .k-input-inner, .k-picker-md .k-input-inner {
    padding: 8px 8px;
}
.k-input:focus-within {
    border-top-color: transparent;
    border-left-color: transparent;
    border-right-color: transparent;
}
.k-input-solid:focus, .k-input-solid.k-focus {
    border-top-color: transparent !important;
}
.k-list-md .k-list-item, .k-list-md .k-list-optionlabel {
    padding: 2px 8px;
}
.k-picker {
    background-color: transparent;
}
.k-filtercell .k-color-picker, .k-filtercell .k-colorpicker, .k-filtercell .k-dropdown-operator {
    border-bottom-style: none;
}
.k-button-solid-base:disabled, .k-button-solid-base.k-disabled {
    visibility: hidden;
}
.k-button-solid-base {
    box-shadow: none;
}
input.k-input, textarea.k-textarea {
    padding: 8px 8px;
}
`;
